module.exports = __webpack_public_path__ + "static/media/empty.682c0e6b.gif";